// extracted by mini-css-extract-plugin
module.exports = {"examBgContainer":"ExamBgContainer_examBgContainer__3jEjJ","pcInstructor":"ExamBgContainer_pcInstructor__1dLnK","instructorInfo":"ExamBgContainer_instructorInfo__zwiuV"};